import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import { Menu } from "primereact/menu";
import { confirmDialog } from "primereact/confirmdialog";
import { InputComponent } from "../InputComponent";
import { TablaDinamica } from "../TablaDinamica";
import * as generic from "../Generico";
import { useLazyParams } from "../../hooks/useLazyParams";
import { Deuda } from "../../models/trust/empleado/Deuda";
import { DeudaService } from "../../service/trust/empleado/DeudaService";

export const DeudaContraida = ({ toast, id, catalogos, permss, soloLectura }) => {

    const omodel = new Deuda();
    const defaultValues = generic.funDefault(omodel.model, null);

    const [dialogVisible, setDialogVisible] = useState(false);
    const [registroSeleccionado, setRegistroSeleccionado] = useState(null);
    const [esOtroCredito, setEsOtroCredito] = useState(false);
    const menuRef = useRef(null);

    const deudaSrv = new DeudaService();
    const tablaDeuda = useLazyParams({ modelo: omodel.model });

    const { control, formState: { errors }, handleSubmit, reset, setError, getValues, setValue } = useForm({ defaultValues });
    const { inText, inDrop, inNumber } = InputComponent({ omodel, errors, control, permss, id: getValues('id'), soloLectura });

    useEffect(() => {
        if (id) loadLazyData();
        // eslint-disable-next-line
    }, [tablaDeuda.lazyParams, id]);

    const loadLazyData = () => {
        tablaDeuda.setLoading(true);
        const _params = { ...tablaDeuda.lazyParams, idp: id };
        deudaSrv.getLista({ lazyEvent: JSON.stringify(_params) }).then(res => {
            tablaDeuda.setTotalRecords(res.data.total);
            tablaDeuda.setData(res.data.registros);
        }).finally(() => tablaDeuda.setLoading(false));
    };

    const openNew = () => {
        reset(defaultValues);
        setEsOtroCredito(false);
        setDialogVisible(true);
    };

    const hideDialog = () => setDialogVisible(false);

    const onSubmit = (data) => {
        data.idp = id;
        data.otro = catalogos?.otro_credito;

        const request = getValues('id') == null
            ? deudaSrv.nuevo(data)
            : deudaSrv.editar(data);

        request.then(res => {
            setDialogVisible(false);
            loadLazyData();
            generic.funcSuccess(res, toast);
        }).catch(error => generic.funcErrorHibrida(error, toast, setError));
    };

    const editRegistro = (idReg) => {
        deudaSrv.consultar(idReg).then(res => {
            const _data = res.data.deuda;
            setEsOtroCredito(_data.tipo_credito?.cat_id === catalogos?.otro_credito?.cat_id);
            reset(generic.renewValues(_data, omodel.model));
            setDialogVisible(true);
        });
    };

    const onChangeTipoCredito = (e) => {
        setEsOtroCredito(e.value?.cat_id === catalogos?.otro_credito?.cat_id);
        setValue('otro_tipo_credito', '');
    };

    const confirmDelete = (idReg) => {
        confirmDialog({
            message: '¿Está seguro de eliminar esta deuda contraída?',
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                deudaSrv.eliminar(idReg).then(res => {
                    loadLazyData();
                    generic.funcSuccess(res, toast);
                }).catch(error => generic.funcDeleteError(error, toast));
            }
        });
    };

    const itemsMenu = () => {
        if (soloLectura) {
            return [{
                label: 'Opciones',
                items: [{ label: 'Ver detalle', icon: 'pi pi-eye', command: () => editRegistro(registroSeleccionado?.id) }]
            }];
        }
        return [{
            label: 'Opciones',
            items: [
                { label: 'Editar', icon: 'pi pi-pencil', command: () => editRegistro(registroSeleccionado?.id) },
                { label: 'Eliminar', icon: 'pi pi-trash', command: () => confirmDelete(registroSeleccionado?.id) }
            ]
        }];
    };

    const accionesTemplate = (rowData) => (
        <Button icon="pi pi-caret-down" type="button" className="p-button-rounded p-button-success mr-2" title="Opciones/Acciones" aria-controls="popup_menu_deuda" aria-haspopup onClick={(e) => { setRegistroSeleccionado(rowData); menuRef.current.toggle(e); }} />
    );

    const ColumnaAcciones = (
        <Column header="Acciones" body={accionesTemplate} style={{ width: '4rem', textAlign: 'center' }} frozen alignFrozen="right" />
    );

    const cabeceraTabla = () => (
        <div className="flex align-items-center justify-content-start gap-3 py-1">
            {permss?.crear && id && !soloLectura && (
                <Button icon="pi pi-plus" className="p-button-success p-button-sm" type="button" onClick={openNew} />
            )}
            <span className="text-sm font-semibold text-600 uppercase tracking-wider">
                Listado de Deudas Contraídas
            </span>
        </div>
    );

    return (
        <div className="componente-deuda-contraida">
            <Menu model={itemsMenu()} popup ref={menuRef} id="popup_menu_deuda" />
            <TablaDinamica modelo={omodel.model} estadoTabla={tablaDeuda} datos={tablaDeuda.data} totalRegistros={tablaDeuda.totalRecords} dataKey="id" acciones={ColumnaAcciones} header={cabeceraTabla()} />

            <Dialog visible={dialogVisible} header={getValues('id') == null ? "Nueva Deuda Contraída" : "Editar Deuda Contraída"} modal className="p-fluid modal-ssize dialog-personalizado" onHide={hideDialog} style={{ width: '580px' }}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="formgrid grid px-2">

                        <div className="col-12 mb-3">
                            <div className="flex align-items-center">
                                <span className="text-800 font-bold text-base mr-3 flex align-items-center gap-2">
                                    <i className="pi pi-wallet text-primary"></i>
                                    DEUDA CONTRAÍDA
                                </span>
                                <div className="border-bottom-1 border-300 flex-grow-1" style={{ height: '1px' }}></div>
                            </div>
                        </div>

                        {inDrop('tipo_credito', catalogos?.tipo_credito, { lab: omodel.optionLabel, chn: onChangeTipoCredito }, esOtroCredito ? 6 : 12)}
                        {esOtroCredito && inText('otro_tipo_credito', { icon: 'pi pi-pencil' }, 6)}
                        {inText('nombre_acreedor', { icon: 'pi pi-user' }, 12)}
                        {inDrop('pais', catalogos?.pais, { lab: omodel.optionLabel }, 6)}
                        {inNumber('valor', 2, false, { prefix: '$ ' }, 6)}

                        <div className="col-12 mt-4 pt-3 flex justify-content-end border-top-1 border-300">
                            {soloLectura ? (
                                <div className="field col-auto p-0 m-0">
                                    <Button label="Cerrar" style={{ width: '120px' }} icon="pi pi-times" type="button" className="p-button-warning" onClick={hideDialog} />
                                </div>
                            ) : (
                                generic.buttonsForms(hideDialog)
                            )}
                        </div>

                    </div>
                </form>
            </Dialog>
        </div>
    );
};
